// src/pages/Login.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Login.module.css";
import companyLogo from "../assets/logo.jpg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (userDoc.exists()) {
        const role = userDoc.data().role?.toLowerCase();
        switch (role) {
          case "admin": navigate("/dashboard/admin"); break;
          case "rsm": navigate("/dashboard/rsm"); break;
          case "so": navigate("/dashboard/so"); break;
          case "dealer": navigate("/dashboard/dealer"); break;
          case "logistic": navigate("/dashboard/logistic"); break;
          case "owner": navigate("/dashboard/owner"); break;
          case "factoryprocgm": navigate("/dashboard/direct"); break;
          case "directsales": navigate("/dashboard/directsales"); break;
          default: navigate("/dashboard");
        }
      } else {
        setError("User data not found in Firestore.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.headerSpace}></div>

      <div className={styles.loginCard}>
        <img src={companyLogo} alt="Company Logo" className={styles.logo} />
        <h1 className={styles.title}>RIFAAH CROP SCIENCES</h1>
        <p className={styles.tagline}>Growing with Power</p>

        {error && <p className={styles.error}>{error}</p>}

        <form onSubmit={handleLogin} className={styles.form}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />
          <button type="submit" className={styles.button} disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>

      <div className={styles.footerSpace}>
        <p>© 2025 RIFAAH Crop Sciences Pvt. Ltd.</p>
      </div>
    </div>
  );
};

export default Login;
